


















import {Component, Vue} from "vue-property-decorator";

import {Store} from "@/enums/Store";

import {User} from "@/util/User";

import {namespace} from 'vuex-class'

const INVOICE_RECIPIENT = namespace(Store.INVOICE_RECIPIENT);
const CART = namespace(Store.CART);

@Component({})
export default class SuccessPage extends Vue {
  @INVOICE_RECIPIENT.State('invoiceRecipient') invoiceRecipient!: User;
  @INVOICE_RECIPIENT.State('hasForeignInvoiceRecipient') hasForeignInvoiceRecipient!: boolean;
  @CART.State('orderId') orderId?: number | string;

  created(): void {
    if (!this.hasForeignInvoiceRecipient) {
      this.redirectIfPayer();
    }
    localStorage.clear()
  }

  get showRedirectMessage(){
    return this.hasForeignInvoiceRecipient;
  }

  async redirectIfPayer() {
    try {
      const result = await this.$api.get<string>(`/magic/create/${this.invoiceRecipient.email}/${this.orderId}`, undefined, false);

      setTimeout(() => {
        window.location.replace(result)
      }, 3000)

    } catch (error) {
      console.error(error)
    }
  }
}
